import $ from "jquery";
import CONFIG from "@bd-core/config";
// import bdapi from "@bd-core/bd-api";
import { getState } from "@bd-stores/store";

export default class Timer {
  constructor(timeoutCallback) {
    this.timeoutCursor = null;
    this.timeoutCallback = timeoutCallback;
    this.remainingTime = null;
    this.isPaused = false;
    this.pausedAt = null;
    this.timeLeft = null;
    this.currentWeatherClass = null;
    this.elms = {
      timer: ".js-timer-text",
      timerRemaining: ".js-timer-remaining",
    };
  }

  getTimerMode() {
    return CONFIG.game_options.timer_config.timer_mode;
  }

  isCountDown() {
    return this.getTimerMode() === "count_down";
  }

  isCountUp() {
    return this.getTimerMode() === "count_up";
  }

  getLimitInSeconds() {
    const limit = CONFIG.game_options.timer_config.timer_limit || 0;
    return limit * 60;
  }

  getDisplaySeconds() {
    const now = Math.floor(Date.now() / 1000);
    const { startedAt, shouldFinishAt } = getState().gameProgress;

    if (this.isCountUp()) {
      if (!startedAt) return 0;
      return Math.max(0, now - startedAt);
    }

    if (!shouldFinishAt) return 0;
    return Math.max(0, shouldFinishAt - now);
  }

  getElapsedSeconds(displaySeconds) {
    if (this.isCountDown()) {
      const limitInSeconds = this.getLimitInSeconds();
      if (limitInSeconds > 0) {
        return limitInSeconds - displaySeconds;
      }
    }

    return displaySeconds;
  }

  updateWeatherWidget(elapsedSeconds) {
    const animations = CONFIG.weather_widget?.weather_animations;
    if (!animations?.length) return;

    const updateTextWithSlideUp = ($el, newText) => {
      if ($el.length === 0) return;
      const currentText = $el.text().trim();
      if (currentText === newText.trim()) return;

      // If it was empty (initial load / re-render), set immediately without animation
      if (currentText === "") {
        $el.html(newText);
        return;
      }

      // Prevent double animating if already in transition
      if ($el.hasClass("weather-text-slide-out") || $el.hasClass("weather-text-slide-in")) {
        return;
      }

      $el.addClass("weather-text-slide-out");
      
      setTimeout(() => {
        $el.html(newText);
        $el.removeClass("weather-text-slide-out").addClass("weather-text-slide-in");
        
        setTimeout(() => {
          $el.removeClass("weather-text-slide-in");
        }, 250);
      }, 200);
    };

    let accumulatedSeconds = 0;
    let activeItem = null;

    for (const item of animations) {
      const durationSeconds = Number(item.timer) * 60;
      if (
        elapsedSeconds >= accumulatedSeconds &&
        elapsedSeconds < accumulatedSeconds + durationSeconds
      ) {
        activeItem = item;
        break;
      }
      accumulatedSeconds += durationSeconds;
    }

    if (!activeItem) {
      if (elapsedSeconds < accumulatedSeconds) return;
      activeItem = animations[animations.length - 1];
    }

    const { degree, weather_label } = activeItem;
    const weatherClass = `is-${weather_label.replace("_", "-")}`;

    const $weatherWidget = $(".js-weather-widget");
    const $weatherTemp = $(".js-weather-temp");

    if (
      this.currentWeatherClass === weatherClass &&
      $weatherWidget.hasClass(weatherClass) &&
      $weatherTemp.text().trim() !== ""
    ) {
      return;
    }

    let weatherTxt = weather_label?.replace("_", " ");
    weatherTxt = weatherTxt.charAt(0).toUpperCase() + weatherTxt.slice(1);

    const allWeatherClasses = animations
      .map((item) => `is-${item.weather_label.replace("_", "-")}`)
      .join(" ");

    this.currentWeatherClass = weatherClass;

    $weatherWidget
      .removeClass(allWeatherClasses)
      .addClass(weatherClass);
    updateTextWithSlideUp($weatherTemp, `${degree}°`);
    updateTextWithSlideUp($(".js-weather-condition"), weatherTxt);
  }

  getPercentage(displaySeconds) {
    const limitInSeconds = this.getLimitInSeconds();

    if (this.isCountUp()) {
      const reference = limitInSeconds || 60 * 60;
      return Math.min(100, (100 * displaySeconds) / reference);
    }

    if (limitInSeconds <= 0) return 0;
    return (100 * displaySeconds) / limitInSeconds;
  }

  init() {
    if (!CONFIG.game_options.timer_config.is_enable_timer) return false;

    const timerMode = this.getTimerMode();
    if (timerMode !== "count_down" && timerMode !== "count_up") {
      return false;
    }

    if (this.timeoutCursor) {
      clearInterval(this.timeoutCursor);
    }

    const displaySeconds = this.getDisplaySeconds();

    if (this.isCountDown() && displaySeconds <= 0) {
      this.updateTimer("00", "00", "00", "0");
      return false;
    }

    if (this.isCountUp() && !getState().gameProgress.startedAt) {
      return false;
    }

    const tick = () => {
      const seconds = this.getDisplaySeconds();
      const percentage = this.getPercentage(seconds);
      const objTimer = this.toTimeObject(seconds);
 
      this.updateWeatherWidget(this.getElapsedSeconds(seconds));

      this.updateTimer(objTimer.h, objTimer.m, objTimer.s, percentage);

      if (this.isCountDown() && seconds <= 0) {
        clearInterval(this.timeoutCursor);

        if (typeof this.timeoutCallback === "function") this.timeoutCallback();
      }
    };

    this.timeoutCursor = setInterval(tick, 1000);
    tick();

    return this;
  }

  toTimeObject(time) {
    const cleanTime = Math.max(0, time);
    const hours = Math.floor(cleanTime / (60 * 60));
    const minutes = Math.floor((cleanTime / 60) % 60);
    const seconds = Math.floor(cleanTime % 60);

    return {
      h: hours.toString().padStart(2, "0"),
      m: minutes.toString().padStart(2, "0"),
      s: seconds.toString().padStart(2, "0"),
    };
  }

  updateTimer(h, m, s, percent) {
    if (this.isPaused) return false;
    let scnd = `<span class="hour">${h}</span>:<span class="minute">${m}</span>:<span class="second">${s}</span>`;
    percent = percent < 0 ? 0 : percent;
    percent = Math.floor(percent);

    if (this.isCountDown() && percent < 20) {
      $(".js-timer").addClass("is-almost-end").removeClass("is-mid-warning");
    } else if (this.isCountDown() && percent < 50) {
      $(".js-timer").addClass("is-mid-warning").removeClass("is-almost-end");
    } else {
      $(".js-timer").removeClass("is-almost-end is-mid-warning");
    }

    $(this.elms.timer).html(scnd);
    $(this.elms.timerRemaining).css("--p", percent);
  }

  start() {
    this.isPaused = false;
    this.init();
  }

  stopTimer() {
    clearInterval(this.timeoutCursor);
  }

  pauseTimer() {
    if (!this.isCountDown() || this.isPaused) return;

    const secondsRemaining = this.getDisplaySeconds();

    this.isPaused = true;
    this.pausedAt = secondsRemaining;
    this.timeLeft = secondsRemaining;

    clearInterval(this.timeoutCursor);
    // $(".js-timer").addClass("is-paused");
    // bdapi.post("game/update-timeleft", {
    //   timeLeft: secondsRemaining,
    // });
  }

  continueTimer() {
    if (!this.isPaused) return;

    this.isPaused = false;
    $(".js-timer").removeClass("is-paused");
    this.start();
  }

  timeLeftToSeconds(shouldFinishAt, finishedAt) {
    const { startedAt } = getState().gameProgress;

    if (this.isCountUp()) {
      if (!startedAt || !finishedAt) return "00:00:00";

      const elapsed = finishedAt - startedAt;
      const hours = Math.floor(elapsed / 3600);
      const minutes = Math.floor((elapsed % 3600) / 60);
      const seconds = Math.floor(elapsed % 60);

      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    }

    const timeDiff = Math.max(0, shouldFinishAt - finishedAt);
    const timeLimit = (CONFIG.game_options.timer_config.timer_limit ?? 20) * 60;

    if (timeDiff > timeLimit) {
      return "00:00:00";
    }

    const hours = Math.floor(timeDiff / 3600);
    const minutes = Math.floor((timeDiff % 3600) / 60);
    const seconds = Math.floor(timeDiff % 60);

    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }
}
